exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.transfer-success-progress {\n  width: 250px;\n  height: 100%;\n  float: right;\n}\n.transfer-success-footer {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.6);\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/prod/mcFrontend2/src/components/common/tabs/tabs_detailed_progress/tab_successful_tasks.vue"],"names":[],"mappings":";AAAA;EACE,aAAa;EACb,aAAa;EACb,aAAa;CACd;AAED;EACE,gBAAgB;EAChB,0BAA0B;CAC3B","file":"tab_successful_tasks.vue","sourcesContent":[".transfer-success-progress {\n  width: 250px;\n  height: 100%;\n  float: right;\n}\n\n.transfer-success-footer {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.6);\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eac7100c","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_successful_tasks.vue
// module id = BT1Z
// module chunks = 1